/* eslint-disable quotes */
// Franncês
export const frances = {
  start: "Commencer",
  save: "Enregistrer",
  delete: "Supprimer",
  update: "Mettre à Jour",
  lets: "Jouons",
  permanentbuy: "Achat Permanent",
  signature: "Abonnement Mensuel",
  signatureano: "Abonnement Annuel",
  male: "Masculin  ",
  female: "Féminin",
  ambos: "les deux",
  inicio9: "Aide",
  choosecategory: "Choisir la Catégorie",
  categories: "Catégories",
  light: "Doux",
  preliminary: "Préliminaire",
  oral: "Oral",
  anal: "Anal",
  hot: "Chaud",
  extreme: "Extrême ",
  vd: "Vérité?",
  dare: "Action?",
  truth: "Vérité",
  time: "Temps ",
  createMyChallenges: "Créer mes Propres Défis",
  chosen: "Sélectionné",
  text3: "Laissez l'amour couler en vous!",
  text4: "Préparez-vous à vivre intensément",
  close: "Fermé",
  dev: "Développé par Dev12BR",
  next: "SUIVANT",
  config3: "Aucune publicité",
  config4: "Choisir des avatars pour améliorer",
  config9: "Créer et modifier vos propres défis",
  version: "Version Premium",
  alert3: "Veuillez sélectionner au moins une catégorie",
  tituloAlert1: "⚠️ Le jeu est sur le point de commencer 😜",
  duvidas: " Questions ou suggestions - Défis chaud",
  description: "Bonjour, ma question ou suggestion est :",
  contact: "Contact",
  botaoApple: "Restaurer les achats",
  alertCompra: "Votre achat est en cours de restauration",
  NotPurchase: "Vous n'avez aucun achat.",
  options: "Options ",
  avalie: "Noter",
  novaCategoria: "Mes Catégories",
  alterLanguage: "Changer de langue?",
  textLanguage:
    "Lorsque vous sélectionnez une nouvelle langue, l'application redémarrera.",
  textLanguage1: "Changer de Langue",
  cancel: "Annuler ",
  languages: "Langues",
  deletCat: "Supprimer la catégorie",
  textDeletCat:
    "En supprimant cette catégorie, les défis présents dans cette catégorie seront supprimés. Cette action ne peut plus être annulée après son exécution.",
  deletDes: "Supprimer le défi",
  textDeletDes: "Cette action ne peut plus être annulée après son exécution.",
  desafio: "Enregistrer un nouveau défi",
  desafiotexto: "Défi",
  textoeditDesafio: "Qui peut faire ça?",
  textEmquem: "Qui  ? ",
  nome: "Nom",
  inicio: "Commencer le jeu",
  cadastrarCategory: "Ajouter une nouvelle catégorie",
  inicio15: "Création d'une nouvelle catégorie",
  inicio16:
    "Étape 1 : Appuis sur le bouton avec le signe + qui se trouve en bas de cet écran. Après ça, une fenêtre apparaîtra pour entrer dans votre nouvelle catégorie.",
  inicio17: "Étape 2 : Entre ta nouvelle catégorie et clique sur enregistrer",
  inicio18:
    "Étape 3 : Pour éditer cette catégorie ou y AJOUTER DES DÉFIS, clique dessus.",
  inicio19:
    "Étape 4 : Sur l'écran suivant, en appuyant sur le bouton indiqué par la flèche ⬆️, une fenêtre s'ouvrira pour éditer ta nouvelle catégorie. ",
  inicio20:
    "Étape 5 : Sur l'écran suivant, en appuyant sur le bouton indiqué par la flèche ⬆️, tu supprimeras la catégorie.",
  inicio21:
    "Étape 1 : Appuis sur le bouton ci-dessous pour ajouter un nouveau défi à cette catégorie",
  inicio22: "Créant un nouveau défi",
  inicio23:
    "Étape 2 : Clique sur chaque élément encerclé pour connaître en détail chaque champ d'enregistrement",
  inicio24: "Texte du défi",
  inicio25: `Écrive le défi à ton guise, et pour que le nom du joueur s'affiche dans le défi, appuis simplement sur le bouton rouge ci-dessous.
    
Cela ajoutera les caractères suivants {nome}.

** NE MODIFIE PAS CES CARACTÈRES ** Pour que le nom s'affiche en conséquence, il doit être comme décrit ci-dessous ⬇️⬇️⬇️⬇️

Défi: embrasse le cou de {nome} `,
  inicio26: "Qui peut faire et qui peut recevoir ",
  inicio27: `Sélectionne « Les deux » si le défi peut être lancé et reçu par des participants des « deux » genres.
  
Si le défi est dirigé vers un genre, il suffit de sélectionner celui souhaité.`,
  inicio28: "Ajoutant du temps au défi",
  inicio29:
    'Dans le cas où ton défi a un temps, faites simplement glisser la "plage" ci-dessous, et la valeur sera affichée au-dessus. Après l\'expiration de la minuterie dans le défi, un son retentira annonçant que le défi est terminé.',
  aviso12: `Ici, tu crées uniquement la catégorie !
    
Pour ajouter les défis, appuis simplement sur le bouton de la catégorie qui vient d'être créée ⬆️⬆️⬆️⬆️`,
  voltar: "Retour",
  semDe: "Joueur sans défis",
  semDe2: `Enregistre au moins un défi pour ce joueur 😬.
  
Tu vas être redirigé vers l'écran de connexion.`,
  term: "Confidentialité",
  Potitic: "Modalités",
  adquirited: "Acheté",
  config10: "Catégories exclusives",
  config11: "+ de 800 nouveaux défis",
  camera: "Appareil photo",
  galery: "Gallerie",
  avatar: "Avatars",
  image: "Image",
  seletion: "Sélectionné",
  editCategory: "Modifier la catégorie",
  frase1: "Aimez-vous les défis ?",
  frase2: "Et si vous essayiez les défis Premium ?",
  //err texto

  errTexto:
    "Si vous avez trouvé une erreur de traduction, veuillez corriger la phrase dans le champ ci-dessous:",
  errTitulo: "Vous avez remarqué quelque chose d'incorrect ?",
  errCorrect: "Comment serait-ce en français ?",
  thisLanguageIsCorrect: "Le défi en FRANÇAIS est-il correct ?",
  yes: "Oui",
  no: "Non",
  errSend: "Envoyer la suggestion",
  send: "Envoyer",
  share: "Partager",
  fraseShare: `Quelle application géniale ! Je partage car je sais que vous l'aimerez aussi ! 
Téléchargez-la, je suis sûr que vous passerez un bon moment, lol... 😉
  
  
Lien de téléchargement : https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇫🇷",

  morePlayer: "Jouer avec plus de joueurs ?",
  players: "Joueurs",
  carregar: "Télécharger une image",
  takePhoto: "Prendre une photo ou sélectionner une image",
  useAvatar: "Ou utiliser des avatars",

  hetero: "Hétéro",
  gay: "Gay",
  lesbico: "Lesbienne",

  nomeHomem1: "Nom de l'homme",
  nomeHomem2: "Nom de l'homme",
  nomeMulher1: "Nom de la femme",
  nomeMulher2: "Nom de la femme",
  messageErr: "Ajoutez les joueurs 🙌",
  descricaoErr: "Entrez les noms des participants ✍️",
  why: "Dites nous pourquoi...",
  later: "Évaluer plus tard",
  txtCard1: "Votre tour 🔥",
  txtCard2: "Réalisez-le 😘",
  txtCard3: "Allez ! 😜",
  txtCard4: "Prochain défi 😈",
  txtCard5: "Encore un ! 👄",

  tituloBloco1Novo: "Explorez l'Intimité Sexuelle avec votre Partenaire",
  subtitulo1Novo: `Plus d'1 million de couples heureux`,
  texto1Novo:
    "Découvrez l'intimité entre vous et votre partenaire et accédez aux meilleurs jeux pour couples ! Débloquez maintenant tous les jeux avec plusieurs catégories conçues pour vous aider à améliorer le lien avec votre partenaire !",
  tituloBloco2Novo: "De nouvelles expériences et une meilleure relation",
  texto2Novo1: "Profitez de plus de 1500 défis",
  texto2Novo2: "Créez vos propres défis",
  texto2Novo3: "Catégories exclusives",
  texto2Novo4: "Aucune publicité",
  texto2Novo5: "Avatars exclusifs",
  texto2Novo6: "De nouveaux défis chaque jour",
  texto2Novo7: "Jeux fréquemment mis à jour",
  tituloBloco3Novo: "Meilleure note dans la catégorie",
  tituloBloco4Novo: "Avantages pour votre relation:",
  texto4Novo1: "Intimité",
  texto4Novo2: "Désire",
  texto4Novo3: "Légèreté",
  texto4Novo4: "Attraction",
  texto4Novo5: "Connexion",
  texto4Novo6: "Plaisir",

  tituloBloco5Novo: "Ce que les couples en pensent",
  texto5depoimentoTitulo1: "Blade Moody",
  texto5depoimento1: `Je pense que c'est la meilleure application que j'ai trouvée sur mobile jusqu'à présent, érotique et intéressante, aucune des autres applications que j'ai vues ne peut être comparée, alors téléchargez la sans attendre. Ne vous plaignez pas en disant que c'est trop cher. Vous passez à côté d'une superbe appli, pour 10 $. Elle offre de meilleures expériences que les jeux que l'on trouve dans les magasins de loisirs locaux.`,
  texto5depoimentoTitulo2: "Joon Rxs",
  texto5depoimento2:
    "Cette application est incroyable ! Je ne savais pas si je devais la télécharger ou non, mais c'est certainement la meilleure sensation que nous ayons eue ces derniers temps. C'est génial de savoir qu'on peut encore faire beaucoup de choses ensemble. 🤭 Nous avons testé la version payante et ça vaut vraiment le coup, nous n'avions pas encore atteint ce niveau de plaisir.",
  texto5depoimentoTitulo3: "Monique SantosRader",
  texto5depoimento3:
    "Si vous voulez pimenter votre relation, cette application est parfaite ! J'en avais déjà testé d'autres mais aucune ne nous a autant plu que celle-ci. Nos préliminaires étaient beaucoup plus excitants et agréables ( et maintenant imaginez le reste !) Ça vaut vraiment la peine d'acheter la version payante (si vous voulez ressentir un plaisir plus intense) mais la version gratuite est aussi incroyable.",
  texto5depoimentoTitulo4: "Anne owens",
  texto5depoimento4:
    "Excellent ! Très bonne application en effet... Nous avons été très excités pendant la partie ce qui a rendu le sexe beaucoup plus prenant, ce fut un plaisir complet ! Nous avons déjà hâte de rejouer 💦🔥 nous recommandons également la version payante si vous pouvez encaisser l'excitation. 🤤",

  tituloBloco6Novo:
    "Rejoignez des centaines de couples dans le monde et ravivez votre relation. Découvrez plus de 800 défis inédits !",
  texto6Select: "Choisissez votre version :",
  texto6Premium: "Premium",
  texto6Assinatura: "Abonnement",
  texto6Mensal: "Mensuel",
  texto6Anual: "Annuel",
  texto6Vitalicia: "A vie",
  bePremium: `Accédez à l'expérience Premium`,
  buyNew: "Acheter",
  attention: "Attention!",
  changeGender: "Vous avez changé votre orientation sexuelle",

  tituloAvaliacao: "Vous aimez le jeu ?",
  textoAvaliacao: "Évaluez-le et aidez-nous à continuer à nous améliorer !",
  agoraNão: "Pas maintenant",
  enviarAvaliacao: "Envoyer",

  nomeJogo1: "Défis Coquins",
  nomeJogo2: "Action ou Vérité ?!",
  nomeJogo3: "Niveau de coquinerie",
  nomeJogo4: "Roulette Séduction ",
  nomeJogo5: "Phrase du jour",
  naughtyQuiz: "Quizz coquin",

  playAlone: "Jouer en Solo",
  estaSozinho: "Seul(e) ?",
  selectPlayer: "Sélectionner le joueur",

  skip: "Sauter",
  responder: "Envoyer",
  respondaAqui: "Répondre ici",
  config4: "Choisissez des avatars à personnaliser",

  tituloSelect1: "Jouer en Solo ?",
  tituloSelect2: "Répondez à des questions osées !",

  subTituloSelect1: "On vous donne un coup de main !",
  subTituloSelect2: "Découvrez à quel point vous êtes coquin !",
  txtJogador1:
    "Sélectionnez votre joueur et explorez des plaisirs guidés conçus spécialement pour vous !",
  txtJogador2: "Le joueur sélectionné répondra aux questions",
  tituloCena: "QUELS ÉLÉMENTS SOUHAITEZ-VOUS UTILISER ?",
  subTituloCena:
    "Vous n'en avez pas ? Appuyez sur 'Obtenir' et procurez-les dans la boutique partenaire.",
  play: "Jouer",

  titleUserWarning: "Sélectionnez un utilisateur",
  txtUserWarning: "Choisissez un utilisateur pour répondre aux questions",

  shareNivelDeSafadeza:
    "Hé, regarde mon niveau de coquin 😈 Expérimentez des moments intenses de plaisir. Tu devraisses l'essayer aussi 💋 Téléchargez l'application maintenant et préparez-vous à apprécier des défis chauds 🔥 avec votre partenaire ►: ➡️ https://desafiospicantesapp.page.link/sharelevelhot",

  shareDica:
    "Transformez votre vie amoureuse dès maintenant ! Téléchargez l'application et découvrez le secret d'une relation pimentée : ➡️ https://desafiospicantesapp.page.link/tipoftheday",

  resultadoQuiz1: `Tu es une personne réservée, tu n'aimes pas trop la coquinerie, tu préfères quelque chose de plus romantique !`,
  resultadoQuiz2:
    "Tu es tellement romantique que tu préfères ne pas abuser de la coquinerie et préfères une ambiance à la lueur des bougies.",
  resultadoQuiz3: `Tu es une personne assez discrète et tu crois en le fait de garder les choses plus discrètes et privées dans l'intimité.`,
  resultadoQuiz4: `Cela ne signifie pas que tu n'es pas coquin(e) de temps en temps, mais tu préfères réserver tout ce feu pour quelqu'un de très spécial.`,
  resultadoQuiz5: `Ta chaleur est en arrière-plan, mais cela ne change rien au fait qu'il y a de la chaleur !`,
  resultadoQuiz6:
    "Tu aimes explorer de nouvelles expériences, mais toujours avec respect et consentement.",
  resultadoQuiz7:
    "Tu aimes les rendez-vous chauds, pleins de baisers et de câlins. Cependant, il y a aussi un côté de toi qui aime regarder un film tout en tenant la main de ton/ta chéri(e) ou dîner aux chandelles.",
  resultadoQuiz8:
    "Tu es prêt(e) à essayer des choses nouvelles et excitantes, mais toujours de manière responsable.",
  resultadoQuiz9: `Tu es une personne audacieuse et aimes pimenter les choses dans l'intimité de temps en temps.`,
  resultadoQuiz10: `Tu aimes profiter de tous les plaisirs de la vie, et il n'y a pas de limite en ce qui concerne le sexe.`,
  resultadoQuiz11: `Avec toi, il n'y a pas de mauvais moment, et n'importe quand est le bon moment pour un petit plaisir ! Un film romantique ? Seulement s'il s'agit de "50 nuances de Grey" !`,
  resultadoQuiz12: `Pour toi, l'intimité est une aventure constante, et tu n'as pas peur de prendre des risques.`,

  mes: "Mois",
  desafiosRestantesDois: "Il vous reste 2 défis Premium !",
  nenhumDesafioRestante: "Plus aucun défi Premium disponible !",
  tornePremiumAviso1:
    "Devenez premium maintenant et profitez de 1000 défis exclusifs !",
  tornePremiumAviso2:
    "Accédez à des défis illimités, du contenu exclusif et un plaisir sans fin !",
  conteudoPremium: "Vous avez sélectionné un contenu Premium !",
  aproveite4desafios:
    "Profitez de 4 défis premium pour découvrir un plaisir exclusif.",
  calculando: "Calcul des résultats...",
  nivelRomantismo: "Votre niveau de romantisme est...",
  finalizar: "Terminer",
  erroQuizTitulo: "Entrez votre réponse",
  erroQuizFrase: "Pour continuer, entrez votre réponse !",
  new: "Nouvelle Application",

  //resposta quiz safadeza

  resQuiz1: "Doux",
  resQuiz2: "Passionné",
  resQuiz3: "Charmant",
  resQuiz4: "Super coquin",

  texto6Semanal: "Hebdomadaire",
  weekly: "Signature Hebdomadaire",

  tempSemanal: "Facturé chaque semaine",
  tempMensal: "Facturé chaque mois",
  tempAnual: "Facturé chaque année",
  tempSempre: "Paiement unique",
  canceleAny: "Annulez à tout moment",

  //Tela do safadrometro
  Low: "Bas",
  Medium: "Moyen",
  High: "Élevé",
  lifeTime: "Accès à vie",
  notNow: "Pas maintenant, merci",

  match: "MATCH AVEC A.I.",

  dateTitle: "Vous voulez découvrir notre nouvelle application ?",

  dateBody: `Vous voulez discuter avec des bots coquins 😈 et pratiquer votre flirt ? Vous allez vous amuser !🔥`,
  goToDate: "Essayez Date.AI maintenant !",

  goodForU: "Est-ce que ça vous a été utile ?",
  rateOurPerformance: "Évaluez notre performance jusqu'à présent",
  veryGood: "Très bon",
  veryBad: "Très mauvais",
  feedbackChallenge: `Qu'est-ce qui vous inciterait à partager l'application Hot Challenges avec d'autres couples, et pourquoi ?`,
  type: "Tapez votre réponse ici...",
  survey: "Enquête de satisfaction.",
  shareIfConfortable: `N'hésitez pas à partager avec vos amis si vous êtes à l'aise :)`,

  howToPlay: "Comment jouer",
  howToPlayHotChallenge:
    "Préparez-vous à pimenter les choses ! Tirez une carte défi et surprenez votre partenaire avec une action torride !",

  preGameTip1:
    "Libérez vos désirs et créez des moments inoubliables avec votre partenaire !",
  preGameTip2:
    "Enflammez vos passions et créez des moments inoubliables ensemble !",
  preGameTip3:
    "Explorez vos désirs les plus fous et créez des souvenirs inoubliables !",
  preGameTip4: "Libérez vos fantasmes et savourez des moments de pur plaisir !",
  selecionajoagador: `Il est temps de jouer`,
  dica: "Astuce",
  howToPlayNaughty:
    "Sélectionnez vos jouets et objets préférés. Faites tourner la roue et laissez le destin choisir votre prochain défi coquin !",
  howToPlayTruthOrDare:
    "Choisissez votre destin : partagez une vérité ou relevez un défi audacieux. Que le plaisir commence !",
  howToKama1: "Découvrez les Positions du Plaisir – 365 Jours de Passion !",
  howToKama2:
    "Piochez une carte au hasard, essayez la position et explorez ensemble de nouveaux sommets de plaisir !",
  kamaExplain:
    "Débloquez une nouvelle position chaque jour et construisez votre collection ultime de passion – votre voyage de 365 jours de plaisir inoubliable commence ici !",
  howToDo: "Comment faire",
  pergunta: "Question",

  restart: "Redémarrer",
  dialogText1HotChallenges:
    "Vous avez terminé tous les défis disponibles avec les catégories sélectionnées.",
  dialogText2HotChallenges:
    "Sélectionnez plus de catégories ou redémarrez le jeu avec les défis actuels !",
  noChallenges: "Aucun défi !",

  objects: "Objets",
  dialogText1NaughtyGames:
    "Vous avez terminé tous les défis disponibles avec les objets sélectionnés.",
  dialogText2NaughtyGames:
    "Sélectionnez plus d'objets ou redémarrez le jeu avec les défis actuels !",
  unlockPremium: "Débloquer Premium",

  noCategory: "Veuillez choisir au moins une catégorie pour commencer.",
  thanksForFeedback: "Merci de nous aider à améliorer l'expérience !",
  categoryKamasutra: "Choisissez votre passion et jouez !",
  tap: "Appuyez pour révéler votre position !",
  step: "Guide Étape par Étape",
  shareQuizButton: "Partagez votre niveau de malice !",
  tryAgain: "Réessayez",
  unlockAllFun: "Débloquez tout le plaisir",
  limitedOffer: "Offre spéciale pour une durée limitée !",
  fill: "Entrez votre nom et celui de votre partenaire.",

  kamaNotificationTitle: "🔥 Votre nouvelle carte est débloquée !",
  kamaNotificationBody:
    "Votre position du jour {variavel} est prête. Et si vous essayiez quelque chose de nouveau aujourd'hui ? 💋",

  titleNewGame: "Préparez-vous pour le Roleplay !",
  phraseNewGame:
    "Dans la prochaine mise à jour, un nouveau jeu pour explorer vos fantasmes les plus créatifs arrive. Choisissez des personnages, créez des histoires et élevez le plaisir à un tout autre niveau avec votre partenaire. 🔥",
  awaitNewGame: "Attendez-vous à vivre des moments uniques !",

  selectObjects:
    "Sélectionnez deux objets ou plus pour personnaliser votre jeu. Explorez au maximum.",
  soon: "Bientôt",
  wantToBeNotify: "Je veux être notifié",
  ok: "OK",
  vezDe: "TOURNER",

  categoryLabel: "Catégorie",
  descriptionLabel: "Description",

  loginConnect: "Se connecter",
  loginNoAccount: "Vous n'avez pas de compte?",
  loginCreateNow: "Créer maintenant",
  loginOrConnect: "ou connectez-vous avec",

  email: "E-mail",
  password: "Mot de passe",
  loginRegister: "S'inscrire",
  loginAlreadyHas: "Vous avez déjà un compte?",
  enterNow: "Entrez maintenant",

  logout: "Déconnexion",
  customerPortal: "Portail Client",
  installApp: "Installer l'application",
  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/frances.mp4",
};
